var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerSelect1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "1330 0 3585 5000",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,-1) translate(0,-5060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682 5040 c-18 -11 -41 -34 -52 -52 -20 -33 -20 -56 -20 -2388 0 -2332 0 -2355 20 -2388 50 -82 151 -95 218 -28 l37 36 3 1110 2 1110 785 0 785 0 0 -307 c0 -285 1 -310 20 -348 11 -22 34 -49 52 -60 32 -20 54 -20 863 -20 812 0 831 0 864 20 46 27 73 80 68 127 -3 24 -113 236 -308 595 -166 307 -302 563 -302 568 1 6 136 259 302 564 175 321 303 569 307 590 6 46 -19 98 -65 128 l-34 23 -743 0 -743 0 -3 329 -3 329 -25 27 c-52 57 -10 55 -1042 55 -933 0 -954 0 -986 -20z m1778 -1290 l0 -1030 -785 0 -785 0 0 1030 0 1030 785 0 785 0 0 -1030z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSelect1);
export default __webpack_public_path__ + "static/media/markerSelect1.38fcbe9155bfc0d287bc9b536219b7f6.svg";
export { ForwardRef as ReactComponent };